import { Locale } from '@repo/utils'
import { Router } from 'next/router'
import React from 'react'

type ContextType = {
  isOpen: boolean
  handleOpen: () => void
  handleClose: () => void
  onLocaleChange: (targetLocale: Locale) => void
  resolveTranslatedPath: ({
    route,
    asPath,
    currentLocale,
    targetLocale,
  }: {
    route: Router['route']
    asPath: Router['asPath']
    currentLocale: Locale
    targetLocale: Locale
  }) => string | null
}

export const LanguageSwitchContext = React.createContext<ContextType | null>(
  null,
)
